<template>
  <div v-if="selectedCompany.PopUpNotification && selectedCompany.PopUpNotification.Message" class="addtocart">
    <modal v-if="isModalVisible" ref="modal" @close="confirm" full-header :hide-footer="true">
      <template slot="body">
        <div class="container">
          <div class="row">
            <div class="header col-md-12">
              {{ selectedCompany.PopUpNotification.Title }}
            </div>
            <br />
            <div
              class="modalBody ios-scroll col-md-12"
              v-html="selectedCompany.PopUpNotification.Message"
            ></div>
            <div class="modalFooter">
              <button @click="confirm()" class="btn btn-primary" :style="buttonStyles">
                Okay
              </button>
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import modal from "./modal.vue";
export default {
  name: "ConfirmationModal",
  components: { modal },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "selectedCompany",
      "getPopup",
      "buttonStyles",
    ]),
    isModalVisible() {
      if(this.getPopup)
        return this.selectedCompany.PopUpNotification.CreatedOn.seconds > this.getPopup.seconds;
      else
      return true;
    },
  },
  methods: {
    ...mapMutations(["setPopup"]),
    confirm() {
      this.$refs.modal.hideModal();
      this.setPopup(this.selectedCompany.PopUpNotification.CreatedOn);
    },
  },
};
</script>
<style scoped>
.header {
  font-size: 18px;
  color: #585858;
  padding: 19px;
}
.modalBody {
  color: #323639;
  font-size: 15px;
  padding: 0px 19px;
  max-height: 300px;
  overflow-y: scroll;
}
.modalFooter {
  padding: 0px 19px;
  margin-top: 25px;
  width: 100%;
}
.modal-content {
  border-radius: 12px;
}
.modalFooter button {
  width: 100%;
  background: #55a7ff;
  border-radius: 7px;
}
</style>
